import React from 'react';
import { MobileNavigatorContainer, MobileNavigatorPaginatorWrapper, MobileNavigatorPaginator, } from '@@Components/BannersSlider/styled';
export const BannerSliderMobileNavigator = ({ count, current, onChange }) => {
    return (React.createElement(MobileNavigatorContainer, null, [...Array(count)].map((b, i) => (React.createElement(MobileNavigatorPaginatorWrapper, { key: i, onClick: () => onChange(i) },
        React.createElement(MobileNavigatorPaginator, { active: current === i }))))));
};
